import { useState } from 'react';

import { IconFileSpreadsheet } from '../layout/icons';
import { useToast } from '../../lib/toast';

interface ExcelExportButtonProps {
  onExport: () => Promise<void> | void;
  label?: string;
  disabled?: boolean;
  className?: string;
}

export const ExcelExportButton = ({ onExport, label = 'Export Excel', disabled, className }: ExcelExportButtonProps) => {
  const [busy, setBusy] = useState(false);
  const { showToast } = useToast();

  const handleClick = async () => {
    if (busy || disabled) return;
    setBusy(true);
    try {
      await onExport();
    } catch (error) {
      showToast(error instanceof Error ? error.message : 'Unable to export to Excel. Please try again.', 'error');
    } finally {
      setBusy(false);
    }
  };

  return (
    <button type="button" className={`excel-export-button${className ? ` ${className}` : ''}`} disabled={disabled || busy} onClick={() => void handleClick()}>
      <IconFileSpreadsheet />
      {busy ? 'Exporting…' : label}
    </button>
  );
};
